module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-11.e2764052.mp3";